import { Component, Input } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { SearchRequest } from '@app/shared/search/interfaces/search-request';
import { GenericFilterField } from '@app/shared/filter/inputs/filter-field';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dashboard-table-advanced-search',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './dashboard-table-advanced-search.component.html',
  styleUrl: './dashboard-table-advanced-search.component.scss',
})
export class DashboardTableAdvancedSearchComponent {
  @Input()
  searchData: SearchRequest;
  @Input()
  fields: GenericFilterField[];
  @Input()
  title: string;

  constructor(public activeModal: NgbActiveModal) {}

  doSearch(formValues: any) {
    this.activeModal.close(formValues);
  }
}
